'use strict';

import angular from 'angular';
import AddUserController from './adduser.controller';

export default angular.module('updateServerApp.betagroups.adduser', [])
  .controller('BetaGroupsAddUserController', AddUserController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/adduser/index.js